import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${(props) => props.theme.color.medium.default};
  text-align: center;
`;

export const IconWrapper = styled.div`
  font-size: 56px;
  color: ${(props) => props.theme.color.light.shade};
  margin-bottom: 20px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.color.medium.shade};
  ${mediaQuery('small')} {
    font-size: 14px;
  }
  text-align: center;
  margin-bottom: 10px;
  width: 80%;
  max-width: 600px;
`;

export const Text = styled.div`
  margin-bottom: 16px;
  font-size: 16px;
  color: ${(props) => props.theme.color.medium.shade};
  ${mediaQuery('small')} {
    font-size: 14px;
  }
`;
